import React from 'react';
import { FaHandPointRight } from "react-icons/fa6";
import './WhyChoose.css'

const WhyChoose = () => {
    return (
        <div>
            <div className='whychooseDiv'>
                <FaHandPointRight className='righthand' /><p>সরাসরি কৃষকের কাছ থেকে কাঁচামাল সংগ্রহ</p>
            </div>
            <div className='whychooseDiv'>
                <FaHandPointRight className='righthand' /><p>আধুনিক মেশিনে স্বাস্থ্যসম্মত প্রক্রিয়াজাত</p>
            </div>
            <div className='whychooseDiv'>
                <FaHandPointRight className='righthand' /><p>কোনো কৃত্রিম রং বা ক্ষতিকর কেমিক্যাল নেই</p>
            </div>
            <div className='whychooseDiv'>
                <FaHandPointRight className='righthand' /><p>ঘ্রাণ ও স্বাদ অটুট রাখতে এয়ারটাইট প্যাকেজিং</p>
            </div>
            <div className='whychooseDiv'>
                <FaHandPointRight className='righthand' /><p>ন্যায্য দাম ও সারা দেশে ডেলিভারি</p>
            </div>
            <p style={{ fontSize: '30px', fontFamily: 'tiro bangla', fontWeight: '600' }}>তাই আর দেরি কেন?-</p>
        </div>
    );
};

export default WhyChoose;